// import '../scss/style.scss'

import { initGlobals } from './setup/globals'
import { initComponents } from './setup/components'
import { initScrollTrigger } from './setup/scroll-trigger'
import { initSwup } from './setup/swup'
import { initScrollSmoother } from './setup/scroll-smoother'
import { initViewManager } from './setup/view-manager'
import { initPageReveal } from './setup/page-reveal'
import { gsap } from 'gsap'

// 1. Bootstrap application
const bootstrap = () => {
	console.log('Bootstrapping application...')
	const ctx = initGlobals()
	window.ctx = ctx

	//
	initComponents(ctx)
	initScrollTrigger(ctx)
	// initScrollSmoother(ctx);

	// Setup SWUP
	// initSwup(ctx)

	// Setup View Manager
	initViewManager(ctx)

	// Setup page reveal
	const { runPageReveal } = initPageReveal(ctx)
	ctx.runPageReveal = runPageReveal
}

// 2. Initialize application on DOM ready
const initialize = () => {
	const { componentsManager, runPageReveal } = window.app

	if (componentsManager) componentsManager.init()
	if (runPageReveal) runPageReveal('direct')

	const elPageOverlay = document.querySelector('.js-overlay-loader')

	if (elPageOverlay) {
		gsap.fromTo(
			elPageOverlay,
			{ opacity: 1 },
			{
				opacity: 0,
				duration: 0.25,
				delay: 0.3,
				onComplete: () => {
					gsap.set(elPageOverlay, { display: 'none' })
				},
			},
		)
	}
}

// Start
bootstrap()

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initialize, { once: true }) : initialize()

// src/js
// ├── core/
// │   ├── browser.js
// │   ├── components-manager.js
// │   └── view-manager/
// │       ├── navigation-controller.js
// │       └── ...
// ├── setup/
// │   ├── index.js              (boot sequence)
// │   ├── lenis.js
// │   ├── gsap.js
// │   ├── swup.js
// │   └── overlays.js
// ├── components/
// │   ├── dynamic-button/
// │   ├── media/
// │   └── navigation/
// ├── modules/
// │   ├── accordion/
// │   ├── slider/
// │   └── lightbox/
// ├── utils/
// │   ├── dom/
// │   ├── animation/
// │   └── network/
// ├── legacy/
// │   └── _old-components/
// └── index.js
